import{__exports as e}from"../../../../_virtual/weak-memoize.browser.cjs.js";Object.defineProperty(e,"__esModule",{value:!0});e.default=function(e){var r=new WeakMap;return function(t){if(r.has(t))return r.get(t);var a=e(t);return r.set(t,a),a}};
//# sourceMappingURL=weak-memoize.browser.cjs.js.map
